import React from 'react';
import styled from 'styled-components';
import { basicColor } from '@/styles/template';
import { boolean } from 'yup';

const StarSVG = styled.svg<{ transparent?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & .star-path {
    fill: ${({ transparent, theme }) =>
            transparent ? basicColor.transparent : theme.color.LightItem};
  }
`;

const FilledMask = styled.rect<{ fillPercentage: number }>`
  width: ${props => props.fillPercentage}%;
  height: 100%;
  fill: ${basicColor.accent};
  position: absolute;
  top: 0;
  left: 0;
`;

interface StarProps {
	index?: number;
	transparent?: boolean;
	fillPercentage: number;
}

const Star: React.FC<StarProps> = ({ index = 0, fillPercentage, transparent = false }) => {
	return (
			<StarSVG viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transparent={transparent}>
				<defs>
					<mask id={`star-mask-${index}`}>
						<path
							d="M23.5318 10.2554C24.4317 9.33697
                23.9818 7.80632 22.6319 7.50019L17.2322 6.73486C16.6322
                6.5818 16.1823 6.27567 16.0323 5.81647L13.4825 0.918391C12.8825
                -0.30613 11.0826 -0.30613 10.4826 0.918391L8.08281 5.81647C7.93281
                6.27567 7.33285 6.5818 6.88288 6.73486L1.33325 7.50019C0.133325
                7.65326 -0.466636 9.33697 0.433305 10.2554L4.48304 14.2351C4.78302
                14.5412 5.083 15.1534 4.93301 15.6126L4.03307 21.123C3.88308
                22.5006 5.23299 23.419 6.43291 22.8067L11.0826 20.3577C11.5326
                20.0515 12.1325 20.0515 12.7325 20.3577L17.3822 22.8067C18.5821
                23.419 20.082 22.5006 19.782 21.123L18.8821 15.6126C18.7321
                15.1534 19.0321 14.5412 19.3321 14.2351L23.5318 10.2554Z"
							fill="white"
						/>
					</mask>
				</defs>
				<rect width="100%" height="100%" className="star-path" mask={`url(#star-mask-${index})`} />
				<FilledMask fillPercentage={fillPercentage} mask={`url(#star-mask-${index})`} />
			</StarSVG>
	);
};

export default Star;
